
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 4a8 8 0 00-7.112 11.668 1 1 0 01.092.66l-.696 3.388 3.388-.696a1 1 0 01.66.092A8 8 0 1012 4zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.965 9.965 0 01-4.262-.951l-4.537.93a1 1 0 01-1.18-1.18l.93-4.537A9.965 9.965 0 012 12z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 8.001a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 12.001a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z"}})])
          )
        }
      }
    